import "react-native-reanimated";
import { AnonymousWidgetPos } from "../types";

export function getPositionOrdinal(position: AnonymousWidgetPos) {
  "worklet";
  return position.c * 100 + position.y * 10 + position.x;
}

export function getSizeOrdinal(position: AnonymousWidgetPos) {
  "worklet";
  return 10 * (position.h - 1) + (position.w - 1);
}
